var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer text-grey-8 tex-body1 text-weight-light",on:{"click":_vm.handleLogOut}},[_vm._v(_vm._s(_vm.$t(_vm.translations.LOG_OUT)))])}
var staticRenderFns = []

export { render, staticRenderFns }